<template>
  <div class='h100-40 width-100vw noPage'>
    <ejs-grid ref='grid' height='100%' :dataSource='data' :allowPaging='true' :pageSettings='pageSettings' :selectionSettings='selectionOptions' :editSettings='editSettings' :commandClick='commandClickFunc' :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field='taskId' minWidth='10' :headerText='$t("Track.taskID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' minWidth='10' :headerText='$t("Track.resourceName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='reportType' minWidth='10' :headerText='$t("Track.reportType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='reportTypeFormat'></e-column>
        <e-column field='taskTypeID' minWidth='10' :headerText='$t("Track.taskTypeID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskSrc' minWidth='10' :headerText='$t("Track.taskSrc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='taskSrcFormat'></e-column>
        <e-column field='messageType' minWidth='10' :headerText='$t("Track.messageType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='messageTypeFormat'></e-column>
        <e-column field='status' minWidth='10' :headerText='$t("Track.status")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='statusFormat'></e-column>
        <e-column :headerText='$t("Track.delete")' textAlign='Center' width='10%' :commands='commands'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
import { Reorder, Resize, Page, CommandColumn, Edit } from '@syncfusion/ej2-vue-grids';
import socketInstance from '../../../plugins/stompSock';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'monitTable',
  data() {
    return {
      timer1: null,
      clock: null,
      refreshStatus: false,
      selectionOptions: { type: 'Single' },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: true, mode: 'Normal', allowEditOnDblClick: false },
      pageSettings: {
        pageSize: 20
      },
      queryConditions: {
        status: '0',
        keywords: '', // 任务名称模糊查询关键字
      },
      commands: [{ title: this.$t("Track.delete"), operate:'Delete', buttonOption: { cssClass: 'h-btn-refresh e-btn e-tbar-btn icon hero-icon hero-icon-remove' } }],
      data: [],
      primaryDatas: [],
      roleNetMap: {},
      shipColumns: [
        {
          field: 'ShippedDate',
          headerText: 'Shipped Date',
          format: 'yMd',
          textAlign: 'Right',
          width: 150,
          minWidth: 10
        },
        {
          field: 'ShipCountry',
          headerText: 'Ship Country',
          width: 150,
          minWidth: 10
        }
      ],
      websocketSetting: [
        { topic: '/topic/#/OamTaskServer', clientId: 'track', callback: this.websocketCallback }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, Page, CommandColumn, Edit]
  },
  methods: {
    reportTypeFormat(grids, data) {
      const { reportType } = data;
      return reportType === 1 ? this.$t('Track.realTime') : this.$t('Track.file');
    },
    taskSrcFormat(grids, data) {
      return data.taskSrc === 1 ? 'WebLmt' : 'EMS';
    },
    messageTypeFormat(grids, data) {
      return data.messageType === 1 ? this.$t('Track.struct') : this.$t('Track.text');
    },
    statusFormat(grids, data) {
      const { status } = data;
      if (status === 1) {
        return this.$t('Track.implementation');
      }
      if (status === 5) {
        return this.$t('Track.finish');
      }
      return this.$t('Track.hangup');
    },
    commandClickFunc(args) {
      if (args.commandColumn.operate === 'Delete') {
        this.$layer.confirm({
          msg: this.$t('Track.deleteTaskInfo'),
          btn1: { msg: this.$t('Track.cancel') },
          btn2: {
            msg: this.$t('Track.confirm'),
            func: () => {
              this.$axios.post('/lte/ems/track/stopOamtask', {
                taskId: args.rowData.taskId,
                typeId: args.rowData.taskTypeID,
                taskStatus: args.rowData.status,
                neId: args.rowData.neId,
                ip: args.rowData.ip,
                port: args.rowData.port
              }).then((response) => {
                if (response && response.status === 200 && response.data.errorCode === '0') {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
                  this.getTrackListData();
                } else {
                  EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
                }
              });
              args.cancel = true;
            }
          }
        });
      }
    },
    websocketInit() {
      socketInstance.init(this.websocketSetting);
    },
    websocketCallback(msg) {
      const newData = JSON.parse(msg.body);
      const This = this;
      if (This.refreshStatus === true) {
        This.refreshStatus = false;
        This.primaryDatas = [];
        This.data = [];
      }
      for (let i = 0; i < newData.length; i++) {
        if (This.roleNetMap[newData[i].neId] && This.roleNetMap[newData[i].neId] === 1) {
          const status1 = This.queryConditions.status === '0';
          const status2 = parseInt(newData[i].status, 10) === parseInt(This.queryConditions.status, 10);
          const status3 = parseInt(This.queryConditions.status, 10) === 2 && parseInt(newData[i].status, 10) !== 0 && parseInt(newData[i].status, 10) !== 1;
          if (status1 || status2 || status3) {
            if (This.data.findIndex(v => v.taskId === newData[i].taskId) < 0) {
              This.primaryDatas.push(newData[i]);
            }
          }
        }
      }
      This.data = This.primaryDatas.concat();
    },
    getTrackListData() {
      // 获取表格数据
      const This = this;
      if (socketInstance.status === 1) {
        clearInterval(This.clock);
        This.clock = null;
        This.refreshStatus = true;
        This.$axios.get(`/lte/ems/track/queryOamTask/${This.queryConditions.status}`).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === '0') {
            console.log(response.data.errorCode);
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          This.primaryDatas = [];
          This.data = [];
        });
      }
    }
  },
  mounted() {
    const This = this;
    This.websocketInit();
    //权限管控
    This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          This.roleNetMap[response.data[i]] = 1;
        }
        if (response.data.length > 0) {
          This.clock = setInterval(This.getTrackListData, 1500);
          this.timer1=setTimeout(() => {
            if (This.clock != null) {
              clearInterval(This.clock);
              This.clock = null;
              console.log("Track.systemOutTime")
            }
          }, 30000);
        }
      }
    });
  },
  beforeDestroy() {
    try {
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[0].clientId, this.websocketSetting[0].topic);
      clearInterval(this.clock);
      if (this.timer1) {
      clearTimeout(this.timer1);
      this.timer1 = null;
      }
    } catch (e) {
      console.log(e);
    }
  }
};
</script>
